import { PureComponent } from 'react';
import track from 'react-tracking';
import Truncator from '@components/Truncator';
import type { InsiderTransation } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';

import {
  Roles,
  RolesWithTitles,
  TransactionValue,
} from '@/pages/CompanyReport/components/InsiderTradingTransactions';

import {
  Accordion,
  Header,
  Body,
  Date,
  Owner,
  OwnerName,
  ChevronRight,
  ChevronDown,
  TransactionTypePositioned,
} from './styled';

export interface CardProps extends InsiderTransation {
  open: boolean;
  index: number;
  onClick: (index: number) => void;
}

@track(
  ({
    transactionType,
    transactionValue,
    index,
    ownerName,
    ownerType,
    teamTitle,
    boardTitle,
  }) => ({
    type: 'track',
    index,
    ownerName,
    ownerType,
    teamTitle,
    boardTitle,
    transactionType,
    transactionValue,
  })
)
class Card extends PureComponent<CardProps> {
  @track({
    action: 'click',
    modifier: 'transaction',
  })
  handleClick = () => {
    const { onClick, index } = this.props;
    onClick(index);
  };

  render() {
    const { handleClick } = this;
    const {
      open,
      shares,
      priceMax,
      ownerName,
      ownerType,
      teamTitle,
      boardTitle,
      filingDate,
      transactionType,
      transactionValue,
    } = this.props;
    return (
      <Accordion>
        <Header onClick={handleClick}>
          <TransactionTypePositioned type={transactionType}>
            {transactionType}
          </TransactionTypePositioned>
          <TransactionValue type={transactionType}>
            {transactionValue}
          </TransactionValue>
          <Date>{filingDate}</Date>
          <Owner>
            <OwnerName>{ownerName}</OwnerName>
            {(boardTitle || teamTitle) && (
              <Roles boardTitle={boardTitle} teamTitle={teamTitle} />
            )}
          </Owner>
          {!open && <ChevronRight />}
          {open && <ChevronDown />}
        </Header>
        <Truncator open={open} minHeight={0} animationDuration={0.4}>
          <Body>
            <tbody>
              <tr>
                <td>
                  <span>Entity</span>
                </td>
                <td>{ownerType}</td>
              </tr>
              {boardTitle || teamTitle ? (
                <tr>
                  <td>
                    <span>Role</span>
                  </td>
                  <td>
                    <RolesWithTitles
                      boardTitle={boardTitle}
                      teamTitle={teamTitle}
                    />
                  </td>
                </tr>
              ) : null}
              <tr>
                <td>
                  <span>Shares</span>
                </td>
                <td>{shares}</td>
              </tr>
              <tr>
                <td>
                  <span>Max Price</span>
                </td>
                <td>{priceMax}</td>
              </tr>
            </tbody>
          </Body>
        </Truncator>
      </Accordion>
    );
  }
}

export default Card;
